export default function(lang) {
    switch (lang) {
        case 'it':
            return {
                contextButtonTitle: "Menu contestuale del grafico",
                downloadCSV: "Download il file CSV",
                downloadJPEG: "Download l'immagine JPEG",
                downloadPDF: "Download il documento PDF",
                downloadPNG: "Download l'immagine PNG",
                downloadSVG: "Download l'immagine vettoriale SVG",
                downloadXLS: "Download il file XLS",
                exitFullscreen: "Esci dalla modalità schermo intero",
                hideData: "Nascondi il data table",
                loading: "Caricamento in corso...",
                months: ["Gennaio", "Febbraio", "Marzo", "Aprile", "Maggio", "Giugno", "Luglio", "Agosto", "Settembre", "Ottobre", "Novembre", "Dicembre"],
                noData: "Nessun dato da visualizzare",
                printChart: "Stampa il grafico",
                rangeSelectorFrom: "Da",
                rangeSelectorTo:"A",
                resetZoom: "Ripristina lo zoom",
                resetZoomTitle: "Ripristina il livello di zoom 1:1",
                shortMonths: ["Gen", "Feb", "Mar", "Apr", "Mag", "Giu", "Lug", "Ago", "Set", "Ott", "Nov", "Dic"],
                viewData: "Mostra il data table",
                viewFullscreen: "Visualizza a schermo intero",
                weekdays: ["Domenica", "Lunedì", "Martedì", "Mercoledì", "Giovedì", "Venerdì", "Sabato"],

                rangeSelector: {
                    month1: "1m",
                    month3: "3m",
                    month6: "6m",
                    year1: "1a",
                    ytd: "YTD",
                    all: "Tutto"
                },

                dataGrouping: {
                    week: "Settimana da "
                }
            };
    
        case 'es':
            return {
                contextButtonTitle: "Menú contextual del gráfico",
                downloadCSV: "Download CSV",
                downloadJPEG: "Download imagen JPEG",
                downloadPDF: "Download documento PDF",
                downloadPNG: "Download imagen PNG",
                downloadSVG: "Download imagen vectorial SVG",
                downloadXLS: "Download XLS",
                exitFullscreen: "Salir de la pantalla completa",
                hideData: "Ocultar data table",
                loading: "Cargando...",
                months: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
                noData: "No hay información para mostrar",
                printChart: "Imprimir el gráfico",
                rangeSelectorFrom: "De",
                rangeSelectorTo:"A",
                resetZoom: "Restablecer zoom",
                resetZoomTitle: "Restablecer nivel de zoom 1: 1",
                shortMonths: ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"],
                viewData: "Ver data table",
                viewFullscreen: "Ver en pantalla completa",
                weekdays: ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"],

                rangeSelector : {
                    month1: "1m",
                    month3: "3m",
                    month6: "6m",
                    year1: "1a",
                    ytd: "YTD",
                    all: "Todo"
                },

                dataGrouping: {
                    week: "Semana desde "
                }
            };       

        default:
            return {
                contextButtonTitle: "Chart context menu",
                downloadCSV: "Download CSV",
                downloadJPEG: "Download JPEG image",
                downloadPDF: "Download PDF document",
                downloadPNG: "Download PNG image",
                downloadSVG: "Download SVG vector image",
                downloadXLS: "Download XLS",
                exitFullscreen: "Exit from full screen",
                hideData: "Hide data table",
                loading: "Loading...",
                months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
                noData: "No data to display",
                printChart: "Print chart",
                rangeSelectorFrom: "From",
                rangeSelectorTo:"To",
                resetZoom: "Reset zoom",
                resetZoomTitle: "Reset zoom level 1:1",
                shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
                viewData: "View data table",
                viewFullscreen: "View in full screen",
                weekdays: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],

                rangeSelector : {
                    month1: "1m",
                    month3: "3m",
                    month6: "6m",
                    year1: "1y",
                    ytd: "YTD",
                    all: "all"
                },

                dataGrouping: {
                    week: "Week from "
                }
            };       
    }

}